import { useState } from "react";

const useModal = () => {
  const [showModal, setShowModal] = useState(false);

  function toggle() {
    setShowModal(!showModal);
  }

  function closeModal() {
    setShowModal(false);
  }

  return {
    showModal,
    toggle,
    closeModal,
  };
};

export default useModal;
